// extracted by css-extract-rspack-plugin
export default {"wrapper":"i2QTiEUFQ6AV52ha","title":"wk3WOUSM1LkMJEpA","controlWrapper":"pwt6dXlrlI9plP2h","modal":"r7a6sOaImn0Tyd_T","tableWrapper":"XlBeOgxAYcSaOhKy"};